import React from "react";
import $ from "jquery";
import { Carousel } from "antd";
import { imgSrc } from "../../../modules";
import "./slider.css";

// let slider = ["1.jpg", "2.jpg", "3.jpg", "4.jpg", "5.jpg", "6.jpg"];
// slider.reverse();

class SliderComponent extends React.Component {
    render() {
        const { slider } = this.props;
        const mobile = $(window.width) > 991 ? false : true;
        if (!slider || typeof slider != "object") {
            return <div id="home"></div>;
        }
        return (
            <div id="home">
                <Carousel className="main-slider" autoplay autoplaySpeed={mobile ? 4000 : 5000} pauseOnHover={mobile ? true : false} draggable={mobile ? true : false} effect={mobile ? "scrollx" : "fade"} speed={mobile ? 200 : 2000}>
                    {Object.keys(slider).map((key) => {
                        return (
                            <div key={'slider'+key}>
                                <div className="image-slider" style={{ backgroundImage: "url('" + imgSrc(slider[key].image, false, "slider") + "')" }}>
                                    <img src={imgSrc(slider[key].image, false, "slider")} alt={slider[key].name} />
                                </div>
                            </div>
                        );
                    })}
                </Carousel>
            </div>
        );
    }
}

export default SliderComponent;
